
import type { SearchConfiguration } from '@empathybroker/tsclient-play/dist/models/search-configuration'
import type { ConfigurationToolIdEnum } from '../../enums'
import type { DataTableColumn } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import ConfigurationFeaturesStatus from '../../components/configurations/configuration-features-status.component.vue'
import CrudList from '../../components/crud/crud-list.component.vue'
import DataTable from '../../components/crud/data-table.component.vue'
import { UiTooltip } from '../../components/keen-ui'
import { AlignEnum, FeatureIdEnum } from '../../enums'
import { ConfigurationsFormMixin, CrudListMixin, RestrictedMixin } from '../../mixins'
import { ROUTER_CONSTS } from '../../router/router.consts'
import { APP_CONSTS } from '../../store/app/app.consts'

export default defineComponent({
  name: 'SearchConfigurationsList',
  components: {
    ConfigurationFeaturesStatus,
    CrudList,
    DataTable,
    UiTooltip,
  },
  mixins: [CrudListMixin, RestrictedMixin],
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree,
    }),
    tableColumns(): DataTableColumn[] {
      const fieldsMessages = this.messages.fields
      return !this.$epb.oidcLogin
        ? [
            {
              id: 'name',
              text: fieldsMessages.name.label,
              sortable: true,
              width: '75%',
            },
            {
              id: 'keywords',
              text: fieldsMessages.keywords.label,
            },
            ...this.pivotsColumns,
            {
              id: 'modified',
              text: fieldsMessages.features.label,
              width: '13rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'meta.updateDate',
              text: fieldsMessages.updateDate.label,
              sortable: true,
            },
            {
              id: 'meta.user',
              text: fieldsMessages.user.label,
              sortable: true,
            },
            {
              id: 'restricted',
              text: fieldsMessages.restricted.label,
              align: AlignEnum.CENTER,
            },
            {
              id: 'enabled',
              text: fieldsMessages.enabled.label,
              sortable: true,
            },
          ]
        : [
            {
              id: 'name',
              text: fieldsMessages.name.label,
              sortable: true,
              width: '75%',
            },
            {
              id: 'keywords',
              text: fieldsMessages.keywords.label,
            },
            ...this.pivotsColumns,
            {
              id: 'modified',
              text: fieldsMessages.features.label,
              width: '13rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'meta.updateDate',
              text: fieldsMessages.updateDate.label,
              sortable: true,
            },
            {
              id: 'meta.user',
              text: fieldsMessages.user.label,
              sortable: true,
            },
            {
              id: 'enabled',
              text: fieldsMessages.enabled.label,
              sortable: true,
            },
          ]
    },
    readOnlyDataItemIds(): string[] {
      return this.getReadOnlyIdsFromData(this.data)
    },
    tools(): ConfigurationToolIdEnum[] {
      return ConfigurationsFormMixin.computed.tools.bind(this)()
    },
  },
  data() {
    return {
      dataType: ActionTypeEnum.CONFIGURATION,
      routes: {
        create: ROUTER_CONSTS.routes[FeatureIdEnum.CONFIGURATION][DomainEnum.SEARCH].create,
        update: ROUTER_CONSTS.routes[FeatureIdEnum.CONFIGURATION][DomainEnum.SEARCH].update,
      },
      messages: this.$epb.messages.tools.configurations,
    }
  },
  methods: {
    getKeywordsText(configuration: SearchConfiguration): string {
      return configuration.context.keywords.map((keyword: string) => `"${keyword}"`).join(', ')
    },
    onRowClick(dataItem: SearchConfiguration): void {
      if (this.readOnly || this.readOnlyDataItemIds.includes(dataItem.id)) {
        this.navigateToRoute(this.routes.update, dataItem)
      }
    },
  },
})
